import React, { useState } from "react";
import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeftLong, faPlus } from "@fortawesome/free-solid-svg-icons";


import { Loader } from "../../components/utilities/loader";
import { BmsHeader } from "../../components/main-components/app.header";
import { SkewBox } from "../../components/page/skew";
import { categories } from "../../helpers/mock-data";
import { useAuth } from "../../services/authentication/authentication.context";
import { AppAlert } from "../../components/utilities/alert";
import { createTutorial } from "../../services/documents/documents.context";
import { TutorialPreview } from "../../components/forms/tutorial-preview";


export const TutorialAddPage = () => {

    const { token } = useAuth();


    const [inputData, setInputData] = useState({
        jsonText: '',
        title: '',
        field: '',
    });

    const [preview, setPreview] = useState(false);
    const [loading, setLoading] = useState(false);
    const [onAlert, setOnAlert] = useState();

    const isNull = (v) => (v === "" || v === undefined || v === null);

    const validateInput = () => {
        const { title, jsonText, field } = inputData;
        if (isNull(title) || isNull(jsonText) || isNull(field)) {
            setOnAlert({
                caption: 'Input error!',
                message: 'Please provide all required data',
                accept: 'OK',
                acceptAction: () => setOnAlert()
            })
            return false;
        }
        return true;
    }


    const handleSubmit = async () => {
        try {
            setLoading(true);
            const resp = await createTutorial(token, inputData);
            if (resp?.error) {
                setOnAlert({
                    caption: 'Server error!',
                    message: 'Something went wrong',
                    accept: 'OK',
                    acceptAction: () => setOnAlert()
                });
                return;
            }
            setOnAlert({
                caption: 'Success!',
                message: resp?.message,
                accept: 'OK',
                acceptAction: () => setOnAlert()
            })
        } catch (error) {
            console.log({error});
        }finally {
            setLoading(false);
        }
    }




    return (
        <div className="page-body">
            <BmsHeader />
            <SkewBox title={"Add A Tutorial Quiz"} />
            {(loading) && <Loader />}
            {onAlert &&
                <AppAlert
                    caption={onAlert.caption}
                    message={onAlert.message}
                    close={() => setOnAlert(false)}
                    accept={"Ok"}
                    acceptAction={onAlert.acceptAction}
                />
            }
            <div
                className="opt-buttons"
            >
                {preview ? (
                    <button
                        className="adm-add opt-q-button"
                        onClick={() => setPreview(false)}
                    >
                        <span>Exit Preview</span>
                        <FontAwesomeIcon icon={faArrowLeftLong} />
                    </button>
                ) : (
                    <button
                        className="adm-add opt-q-button"
                        onClick={() => {
                            if (validateInput()) {
                                setPreview(true);
                            }
                        }}
                    >
                        <FontAwesomeIcon icon={faPlus} />
                        <span>Preview MCQ's</span>
                    </button>
                )
                }
            </div>
            {preview ?
                <div className="flx-v c-al">
                    <TutorialPreview
                        data={JSON.parse(inputData.jsonText)}
                        savePrev={(v) => setInputData((d) => ({
                            ...d,
                            jsonText: JSON.stringify(v).replace(/\\"/g, '')
                        }))}
                    />
                </div> :
                <form
                    className="form-container"
                    onSubmit={(e) => {
                        e.preventDefault();
                    }}
                >
                    <div className="input-container">
                        <span className="input-cap">
                            Title
                            <span className="req-asterix">*</span>
                        </span>

                        <input
                            type="text"
                            placeholder="Enter tutorial title"
                            className="input"
                            onChange={(e) => setInputData((data) =>
                                ({ ...data, title: e.target.value })
                            )}
                            value={inputData.title}
                        />
                    </div>
                    <div className="input-container">
                        <span className="input-cap">
                            Field of study
                            <span className="req-asterix">*</span>
                        </span>
                        <select
                            type="text"
                            name="category"
                            id="category"
                            className={classNames("input", "category")}
                            required
                            onChange={(e) => setInputData((data) => (
                                { ...data, field: e.target.value }
                            ))}
                        >
                            <option defaultValue={''} selected disabled>
                                ---Choose subject area---
                            </option>
                            {categories.map((category, i) => (
                                <option value={category} key={i} >{category}</option>
                            ))}
                        </select>
                    </div>
                    <div className="input-container flx-v">
                        <span className="input-cap">
                            Enter json
                            <span className="req-asterix">*</span>
                        </span>
                        <textarea
                            name="jsonText"
                            cols={20}
                            rows={30}
                            value={inputData.jsonText}
                            onChange={(e) => {
                                setInputData((data) => ({ ...data, jsonText: e.target.value }))
                            }}
                        />
                    </div>



                    <button
                        className="form-button"
                        onClick={async (e) => {
                            e.preventDefault();
                            if (validateInput())
                                handleSubmit();
                        }}
                    >
                        Upload Tutorial
                    </button>
                </form>}
        </div>
    );
}